import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from 'react-bootstrap-dialog';
import FileUploadMultiple, { File } from 'components/FileUploadMultiple';
import {
  Row,
  Col,
  Modal,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
  Badge,
  Spinner,
  Alert
} from 'react-bootstrap';
import arrayAppend from 'helpers/array-append';
import { api } from 'services';
import DatePicker, { registerLocale } from 'react-datepicker';
import BR from 'date-fns/locale/pt-BR';
import { toast } from 'react-toastify';
import Currency, { currencyReverse, DollarCurrency, EuroCurrency,
  CurrencyPlainText,
  CurrencyDollarPlainText,
  CurrencyEuroPlainText, } from 'helpers/Currency';
import { formatDate, parseDate, parseDateBR } from 'helpers/date';
import { connect } from 'react-redux';
import { LOADING } from 'store';
import PadLock from 'components/PadLock';
import style from './style.module.scss';
import S3Explorer from 'components/S3Explorer/S3Explorer';
import { useLocation } from 'react-router-dom';
import SweetAlert from 'sweetalert2';
import banks from 'helpers/banks_codes.json';
import { DescriptionSharp, InfoRounded, TextFormatOutlined } from '@material-ui/icons';
import Input from 'helpers/Input';
import './style.css';

import ReactTooltip from 'react-tooltip';

import AddFile from "./AddFile";

registerLocale('BR', BR);

const ActionsFormExpenseDescriptions = ({
  loading,
  actionId,
  expenseDescriptions,
  setExpenseDescriptions,
  editable,
  maxValue,
  location,
  showModalFromFiles,
  fileId,
  cleanNFexplorer,
  periodFunds,
  currency,
  funds,
  costCenterObj,
  courtesy,
  setHasValues,
  toSteps,
  setToSteps
}) => {
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState('');
  const [serviceProvider, setServiceProvider] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [value, setValue] = useState('');
  const [valueNonRefundable, setValueNonRefundable] = useState('');
  const [description, setDescription] = useState('');
  const [nature, setNature] = useState('Reembolsável');
  const [costCenter, setCostCenter] = useState(costCenterObj ? costCenterObj.code : '');
  const [project, setProject] = useState('');
  const [projectAction, setProjectAction] = useState('');
  const [files, setFiles] = useState([]);
  const [filesComments, setFilesComments] = useState([]);
  const [addMaxValue, setAddMaxValue] = useState(0);
  const [vinculated, setVinculated] = useState('');
  const [vinculatedFiles, setVinculatedFiles] = useState([]);
  const [fileIdProp, setFileIdProp] = useState(fileId);
  const [total, setTotal] = useState(0);
  const [hasContract, setHasContract] = useState(false);
  const [statusInvoice, setStatusInvoice] = useState('');
  const [disableVinculatedSelect, setDisableVinculatedSelect] = useState(false);
  const [actionIdInvoice, setActionIdInvoice] = useState('');
  const [isLoad, setLoad] = useState(false);
  const [disabledSaveButton, setDisabledSaveButton] = useState(false);
  const [currencyValue, setCurrencyValue] = useState('');
  const [cotacao, setCotacao] = useState('');
  const [document, setDocument] = useState('');

  const [paymentMethod, setPaymentMethod] = useState('');
  const [bankCode, setBankCode] = useState('');
  const [bankName, setBankName] = useState('');
  const [agency, setAgency] = useState('');
  const [account, setAccount] = useState('');
  const [billetDueDate, setBilletDueDate] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [generatePayment, setGeneratePayment] = useState(true);
  const [issuanceDate, setIssuanceDate] = useState('');
  const [isAdvance, setIsAdvance] = useState(false);

  const dueDateMin = new Date(new Date().setDate(new Date().getDate() + 7));

  const [showAddFile, setShowAddFile] = useState(false);
  const [idAddFile, setIdAddFile] = useState(null);

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();

  useEffect(() => {
    var sum = 0;
    expenseDescriptions.filter((description)=>{
      return description.status_id != 7;
    }).forEach((description) => {
      if(description.value_cotacao)
        sum += (description.value/description.value_cotacao)
      else
        sum += (description.value)
    });

    setTotal(sum);
    location &&
      location.includes('file') &&
      setVinculatedFiles(query.get('file')) &&
      setVinculated('exist');
    if (showModalFromFiles) {
      setShowModal(true);
      setVinculated('exist');
      setVinculatedFiles(fileId);
    }   
  }, [expenseDescriptions]);

  const { t } = useTranslation();
  let dialog;

  const handleHideModal = () => {
    setShowModal(false);
    setVinculated('');
    clearInputs();
  };

  const clearInputs = () => {
    setId('');
    setServiceProvider('');
    setDocument('');
    setInvoiceNumber('');
    setDueDate('');
    setValue('');
    setValueNonRefundable('');
    setAddMaxValue(0);
    setDescription('');
    setNature('Não Reembolsável');
    //setCostCenter('');
    setProject('');
    setProjectAction('');
    setFiles([]);
    setFilesComments([]);
    //setVinculated('');
    setVinculatedFiles(0);
    showModalFromFiles && cleanNFexplorer();
    setFileIdProp(0);
    setDisableVinculatedSelect(false);
    setPaymentMethod('');
    setBankCode('');
    setBankName('');
    setAgency('');
    setAccount('');
    setBilletDueDate('');
  }
  
  const handleEdit = (k) => {
    const expenseDescription = expenseDescriptions[k];
    setDisableVinculatedSelect(true);
    setId(expenseDescription.id);
    if (expenseDescription.is_advance) {
      setVinculated('advance')
      setIsAdvance(true);
    } else {
      expenseDescription.vinculated_nf === 1
        ? setVinculated('exist')
        : setVinculated('new');
    }
    
    setServiceProvider(expenseDescription.service_provider);
    setDocument(expenseDescription.document);
    setInvoiceNumber(expenseDescription.invoice_number ?? "");
    setDueDate(expenseDescription.due_date);
    setValue(expenseDescription.value);
    setValueNonRefundable(expenseDescription.non_refundable);
    setAddMaxValue(expenseDescription.value);
    setDescription(expenseDescription.description);
    setNature(expenseDescription.nature);
    setCostCenter(expenseDescription.cost_center);
    setProject(expenseDescription.project);
    setProjectAction(expenseDescription.project_action);
    setHasContract(!!+expenseDescription.has_contract);
    setStatusInvoice(expenseDescription.status_id);
    setShowModal(true);
    setActionIdInvoice(expenseDescription.action_id);
    setCotacao(expenseDescription.value_cotacao);
    setCurrencyValue(expenseDescription.currency.toString());
    setPaymentMethod(expenseDescription.payment_method_id);
    setBankCode(expenseDescription.bank_code);
    setBankName(expenseDescription.bank_name);
    setAgency(expenseDescription.agency);
    setAccount(expenseDescription.account);
    setIssuanceDate(expenseDescription.issuance_date);
    //setBilletDueDate(expenseDescription.billet_due_date && new Date(parseDate(expenseDescription.billet_due_date)));
  };

  const getStatus = (statusParam) =>
      statusParam === 8 ? (
        <Badge variant="success" className="pt-2 pb-2 pr-2 pl-2">
          {t('statuses:approved_nf')}
        </Badge>
      ) : statusParam === 6 ? (
        <Badge variant="warning" className="pt-2 pb-2 pr-2 pl-2">
          {t('statuses:on_approval_nf')}
        </Badge>
      ) : statusParam === 7 ? (
        <Badge variant="danger" className="pt-2 pb-2 pr-2 pl-2">
          {t('statuses:disapproved_nf')}
        </Badge>
      ) : (
        <Badge variant="light" className="pt-2 pb-2 pr-2 pl-2">
          --
        </Badge>
      );

  const deleteDescription = (id) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    dialog.show({
      title: t('title:expense description delete'),
      body: t('phrase:are you sure?'),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          loading(true);
          api.delete(`expense-descriptions/${id}`).then(() => {
            loading(false);
            refreshExpenseDescriptions();
            toast.success('Deletado com sucesso!');
          });
        }),
      ],
      bgSize: 'small',
    });
  };

  const setFileData = (fileData) => {
    setShowModal(true);
    setId('');
    setServiceProvider(fileData.service_provider);
    setDocument(fileData.document);
    setInvoiceNumber(fileData.invoice_number);
    setDueDate(
      fileData.due_date &&
      new Date(parseDate(fileData.due_date))
    );
    setValue(fileData.value);
    setAddMaxValue(0);
    setDescription(fileData.description);
    setNature(fileData.nature);
    //setCostCenter(fileData.expense_description.cost_center);
    setProject(fileData.project);
    setProjectAction(fileData.project_action);
    setVinculatedFiles(fileData.files);
    setFilesComments([]);
    setVinculated('exist');
    setStatusInvoice(fileData.status_id);
    setIssuanceDate(
      fileData.issuance_date &&
      new Date(parseDate(fileData.issuance_date))
    );
    setDisableVinculatedSelect(true);
  };

  const handleSave = () => {
    setLoad(true);
    const formData = new FormData();

    toast.dismiss();

    if (!!id) formData.append('_method', 'put');

    formData.append('action_id', actionId);
    formData.append('service_provider', serviceProvider);
    formData.append('invoice_number', invoiceNumber);
    formData.append('due_date', dueDate ? formatDate(dueDate) : '');
    formData.append('value', currencyReverse(value));
    formData.append('non_refundable', currencyReverse(valueNonRefundable));
    formData.append('description', description);
    formData.append('nature', currencyReverse(value)>0?"Reembolsável":"Não Reembolsável");
    formData.append('cost_center', costCenter);
    formData.append('project', project);
    formData.append('project_action', projectAction);
    formData.append('first_approval', 0);
    formData.append('second_approval', 0);
    formData.append('require_second_approval', 0);
    formData.append('vinculated_nf', vinculated === 'exist' ? 1 : 0);
    formData.append('has_contract', hasContract ? 1 : 0);
    formData.append('document', document);
    formData.append('issuance_date', issuanceDate ? formatDate(issuanceDate) : '');

    formData.append('payment_method_id', paymentMethod);
    formData.append('billet_due_date', paymentMethod == 1 && dueDate ? formatDate(dueDate): "");
    formData.append('bank_code', paymentMethod == 2 ? bankCode : "");
    formData.append('bank_name', paymentMethod == 2 ? bankName : "");
    formData.append('agency', paymentMethod == 2 ? agency : "");
    formData.append('account', paymentMethod == 2 ? account : "");

    formData.append('is_advance', isAdvance ? 1 : 0);
    
    if (vinculated === 'exist') {
      formData.append('status_id', statusInvoice);
    } else {
      formData.append('status_id', 6);
    }
    if (vinculated === 'new' || isAdvance) {
      arrayAppend(formData, 'files', files);
      arrayAppend(formData, 'files_comments', filesComments);
    } else {
      arrayAppend(formData, 'files_id', vinculatedFiles);
    }

    if(getCurrency() === '1' && currency!=='1'){
      formData.append('value_cotacao', cotacao);
      formData.append('currency', 1);
    } else {
      formData.append('currency', currency);
      formData.append('value_cotacao', 1);
    }

    formData.append('generate_payment', parseInt(generatePayment ? 1 : 0));

    formData.forEach((a,k)=>{
    });

    api
      .post(
        !!id ? `expense-descriptions/${id}` : 'expense-descriptions',
        formData, {
          headers: {
            'X-Success-Message': `Nota Fiscal ${vinculated === 'new' ? 'Adicionada' : 'Vinculada' } com sucesso.`,
            'X-Show-Alert': true
          }
        }
      )
      .then(() => {
        handleHideModal();
        !showModalFromFiles ? refreshExpenseDescriptions() : cleanNFexplorer();
        showModalFromFiles && setFileIdProp(0);
        setLoad(false);
      })
      .finally(() => loading(false) && setLoad(false))
      .catch(() => loading(false) && setLoad(false));
  };

  const refreshExpenseDescriptions = async () => {
    return api
      .get(`actions/${actionId}/expense-descriptions`)
      .then(({ data }) => {
        setExpenseDescriptions(
          data
            .filter((comprovation) => comprovation.service_provider !== null)
            .map((description) => {
              return {
                ...description,
                ...{
                  billet_due_date: description.billet_due_date ? new Date(parseDate(description.billet_due_date)):'',
                  due_date: description.due_date?new Date(parseDate(description.due_date)):'',
                  issuance_date: description.issuance_date?new Date(parseDate(description.issuance_date)):'',
                  hidden: true,
                },
              };
            })
        )
        

        setToSteps(old => old.filter(step => step.id !== 19))
      });
  };

  const getBankName = code => {
    const [data] = banks.filter(bank => bank.value == code);
    if(data)
      return `${data.value} - ${data.label}`;
    return '';
  }

  const setHidden = (value, k) => {
    const updateArray = [...expenseDescriptions];
    updateArray[k].hidden = value;
    setExpenseDescriptions(updateArray);
  };

  const getListSelectCurrency = () => {
    let retorno = [
      (<option value="1">R$</option>)
    ];
    if(currency === '2')
    retorno.push((<option value="2">$</option>))
    if(currency === '3')
    retorno.push((<option value="3">€</option>))
    
    return retorno;
  }

  const getListSelectCotacao = () => {
    let pf = periodFunds.filter(a=> funds.filter(b=>b.fund_id === a.id)[0]);
    if(cotacao==='')
    setCotacao(pf[0]?pf[0].value_cotacao:'');
    return pf.map(a=>{
      return (<option value={a.value_cotacao}>{'R$ '+a.value_cotacao.replace('.',',')}</option>)
    });
  }

  const getCurrency = () => {
    return currencyValue !== '' ? currencyValue : currency;
  }

  const getText = () => {
    let valor = (value!==''?parseFloat(currencyReverse(value)).toFixed(2):'0.00').toString().replace('.',',');
    return 'R$ '+valor+' = '+(currency==='2'?'$ ':'€ ')+
    parseFloat((currencyReverse(valor)/(cotacao?cotacao:1)).toFixed(2)).toLocaleString(currency==='2'?'en':'pt');
  }

  const changeValue = (e, setFunction) => {
    const c = () => {
      return getCurrency()==='1'?'R$':(
        getCurrency()==='2'?'$':'€'
      );
    };
    let valor_limite = maxValue + addMaxValue;
    let valor = currencyReverse(e.target.value);
    if(getCurrency() === '1' && currency!=='1')
      valor = valor/(cotacao?cotacao:1);
    if (!courtesy && valor > valor_limite) {
      toast.warning(
        `${t('error:not exceed the value of')} ${c()} ${(
          valor_limite*((getCurrency() === '1' && currency!=='1') && cotacao?cotacao:1)
        ).toLocaleString('pt-BR')}`
      );
      if(getCurrency() === '1' && currency!=='1'){
        setFunction((valor_limite)*(cotacao?cotacao:1));
      }else{
        setFunction(valor_limite);
      }

      return;
    }
    setFunction(e.target.value);
  }

  const getCurrencyTag=(value,setFunction)=>{
    switch (getCurrency()) {
      case '1':
        return ( 
        <Currency
          className="col-auto col-md-10"
          value={value}
          disabled={vinculated.length === 0}
          onChange={(e) => changeValue(e,setFunction) }
          required
        />);
        break;
      case '2':
        return ( 
        <DollarCurrency
          className="col-auto col-md-10"
          value={value}
          disabled={vinculated.length === 0}
          onChange={(e) => changeValue(e,setFunction) }
          required
        />);
        break;
      case '3':
        return ( 
        <EuroCurrency
          className="col-auto col-md-10"
          value={value}
          disabled={vinculated.length === 0}
          onChange={(e) => changeValue(e,setFunction) }
          required
        />);
        break;
    
      default:
        break;
    }
  };

  const bankAccountRender = () => ( // dados conta bancaria 
    <Row>
      <Col xs={12}>
        <Form.Group>
          <Form.Label>Banco</Form.Label>
          <Form.Control
            as="select"
            value={bankCode}
            onChange={(e)=> {
              setBankCode(e.target.value);
              const [data] = banks.filter(bank => bank.value == e.target.value);
              setBankName(data.label);
            }}
          >
            <option value="" selected disabled>Selecione um Banco</option>
            {banks.map(bank => (
              <option value={bank.value.toString()}>{`${bank.value} - ${bank.label}`}</option>
            ))}
          </Form.Control>
        </Form.Group>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>Agência</Form.Label>
          <Form.Control
            value={agency}
            onChange={(e) => setAgency(e.target.value)}
            required={paymentMethod == 2}
          />
        </Form.Group>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>Conta</Form.Label>
          <Form.Control
            value={account}
            onChange={(e) => setAccount(e.target.value)}
            required={paymentMethod == 2}
          />
        </Form.Group>
      </Col>        
      <Col>
        <Form.Group>
          <Form.Label>CNPJ</Form.Label>
          <Form.Control
            value={document}
            required={paymentMethod == 2}
            disabled
          />
        </Form.Group>
      </Col>
    </Row>
  )

  const billetRender = () => ( // dados boleto
    <Row>
      <Col xs={6}>
        <Form.Group>
          <Form.Label>Data de Vencimento</Form.Label>
          <Form.Control 
            value={dueDate ? parseDateBR(formatDate(dueDate)) : ""}
            disabled
          />
        </Form.Group>
      </Col>
    </Row>
  )
  const getDescription = (lista,status) => {
    let texto = '';
    if(status===7){
      lista.filter(a=>a.status_id===7).forEach(i=>{
        texto += `Reprovado pelo ${i.profile.name}.</br>
        <p>Motivo: ${i.description}</p>`;
      });
    } else if(status===8){
      if(lista.length===0){
        texto += 'NF Aprovada'
      }else{
        lista.filter(a=>a.status_id===8).forEach(i=>{
          texto += `NF Aprovada`;
        });
      }
    } else{
      texto += 'Aguardando Aprovação';
    }
    
    return texto;
  };

  const hasFiles = (description) => {
    if (description.is_advance) {
      if (description.advance_children.length) {
        return true;
      }
    } else {
      if (description.files.length) {
        return true;
      }
    }
    return false;
  }

  const listFiles = (description) => {    
    if (description.is_advance) {
      if (description.advance_children.length) {
        return (
          <File
            extension={description.advance_children[0].files[0].extension}
            comment={description.advance_children[0].files[0].comment}
            uri={description.advance_children[0].files[0].uri}
          />
        )
      }
    } else {
      if (description.files.length) {
        return (
          description.files.map((file, k) => (
            <File
              key={k}
              extension={file.extension}
              comment={file.comment}
              uri={file.uri}
            />
          ))
        )
      }
    }
  }

  if (!actionId) return <></>;
  return (
    <>
      <AddFile idAddFile={idAddFile} show={showAddFile} onHide={()=>setShowAddFile(false)} update={refreshExpenseDescriptions}/>
      <Modal size="lg" show={showModal} onHide={handleHideModal}>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Tipo de Nota</Form.Label>
                <Form.Control
                  as="select"
                  value={vinculated}
                  onChange={(e) => {
                    setVinculated(e.target.value);
                    if(e.target.value == 'exist'){
                      setGeneratePayment(false)
                      setDueDate('');
                    }
                    let isAdvance = e.target.value == 'advance'
                    let isCreditCard = e.target.value == 'credit_card'
                    setIsAdvance(isAdvance)
                    setGeneratePayment(isAdvance || isCreditCard)

                    if(isCreditCard){
                      setPaymentMethod(3);
                    }
                  }}
                  required
                  disabled={disableVinculatedSelect}
                >
                  <option disabled value="">
                    {t('label:select')}
                  </option>
                  <option value={'advance'}>Adiantamento</option>
                  <option value={'new'}>{t('label:add new nf')}</option>
                  <option value={'exist'}>{t('label:exist nf')}</option>
                  <option value={'credit_card'}>Cartão de Crédito</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Vai gerar pagamento ?</Form.Label>
                <Form.Control
                  as="select"
                  value={generatePayment ? 1 : 0}

                  onChange={(e) => {
                    setGeneratePayment(e.target.value == 1 ? true : false);
                    if (e.target.value == 0){
                      setPaymentMethod('');
                      setBankCode('');
                      setBankName('');
                      setAgency('');
                      setAccount('');
                      setBilletDueDate('');
                    }
                    setDueDate('');
                  }}
                  disabled={vinculated == 'exist' || vinculated == "advance" || vinculated == "credit_card"}
                >
                  <option value={1}>Sim</option>
                  <option value={0}>Não</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          {vinculated === 'exist' && actionIdInvoice === '' ? (
            <Row className="mb-3">
              <Col>
                <S3Explorer
                  fileId={fileIdProp}
                  setFiles={(vinculatedFiles) =>
                    setVinculatedFiles(vinculatedFiles.files)
                  }
                  setData={(fileData) => setFileData(fileData)}
                  clearData={clearInputs}
                  setVinculated={setVinculated}
                />
              </Col>
            </Row>
          ) : null}
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:service provider')}</Form.Label>
                <Form.Control
                  value={serviceProvider}
                  onChange={(e) => setServiceProvider(e.target.value)}
                  required
                  disabled={vinculated.length === 0}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:registered number')}</Form.Label>                
                <Input.CNPJ
                  value={document}
                  onChange={(e) => setDocument(e.target.value)}
                  required
                  disabled={vinculated.length === 0}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:invoice number')}</Form.Label>
                <Form.Control
                  value={invoiceNumber}
                  onChange={(e) => setInvoiceNumber(e.target.value)}
                  required
                  disabled={vinculated.length === 0}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:expiry')}</Form.Label>
                <DatePicker
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale="pt_BR"
                  selected={dueDate}
                  onChange={(date) => setDueDate(date)}
                  minDate={paymentMethod == 1 ? dueDateMin : ""}
                  disabled={vinculated.length === 0 || !generatePayment || vinculated == "credit_card"}
                  required
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:issuance_date')}</Form.Label>
                <DatePicker
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale="pt_BR"
                  selected={issuanceDate}
                  onChange={(date) => {setIssuanceDate(date);}}
                  disabled={vinculated.length === 0 || vinculated == "credit_card"}
                  // minDate={paymentMethod == 1 ? dueDateMin : ""}
                  required
                />
              </Form.Group>
            </Col>
            {paymentMethod == 1 && showAlert ? (<>
              <Col xs={12}>
                <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
                  <InfoRounded />{' '} 
                  A data de vencimento para BOLETO deve ser de no mínimo 10 dias. Por favor altere a data de vencimento.
                </Alert>
              </Col>
            </>) : null}
          </Row>
          {generatePayment ? (<>
            <Row className="mt-2 mb-1">
              <Col><h5>Pagamento</h5></Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Forma de Pagamento</Form.Label>
                  <Form.Control
                    as="select"
                    value={paymentMethod}
                    onChange={(e) => {
                      setPaymentMethod(e.target.value)
                      if (e.target.value == 1 && dueDate != "") {
                        if (dueDateMin > dueDate) {
                          setDueDate("");
                          setShowAlert(true);
                        }                     
                      }
                    }}
                    disabled={vinculated == "credit_card"}
                  >
                    <option value="" selected disabled>Selecione uma forma de Pagamento</option>
                    <option value={1}>Boleto</option>
                    <option value={2}>Transferência Bancária</option>
                    {vinculated == "credit_card"?(
                      <option value={3}>Cartão de Crédito</option>
                    ):""}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col>
                {paymentMethod == 1 
                  ? billetRender() 
                  : paymentMethod == 2 
                    ? bankAccountRender()
                    : null 
                }
              </Col>
            </Row>
          </>) : null}
          <Row className="mt-2 mb-1">
            <Col>
              <h5>{t('title:project info')}</h5>
            </Col>
          </Row>
          <Row>
            {/* <Col>
              <Form.Group>
                <Form.Label>{t('label:nature')}</Form.Label>
                <Form.Check
                  disabled={vinculated.length === 0}
                  id="nature"
                  checked={nature === "Reembolsável"}
                  onChange={(e) => setNature(e.target.checked ? "Reembolsável" : "Não Reembolsável")}
                  required
                  label={nature || "Não Reembolsável"}
                  type="switch"
                />
              </Form.Group>
            </Col> */}
            <Col>
              <Form.Group>
                <Form.Label>{t('label:cost center')}</Form.Label>
                <Form.Control
                  value={costCenter}
                  onChange={(e) => setCostCenter(e.target.value)}
                  required
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:project')}</Form.Label>
                <Form.Control
                  value={project}
                  onChange={(e) => setProject(e.target.value)}
                  required
                  disabled={vinculated.length === 0}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:project action')}</Form.Label>
                <Form.Control
                  value={projectAction}
                  onChange={(e) => setProjectAction(e.target.value)}
                  required
                  disabled={vinculated.length === 0}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              {vinculated === 'new' ? (
                <Form.Group>
                  <Form.Check
                    id="test"
                    type="checkbox"
                    label={t('phrase:contract')}
                    checked={!!hasContract}
                    onChange={(e) => setHasContract(e.target.checked)}
                  />
                </Form.Group>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col md={getCurrency() === '1' && currency!=='1'?'7':'12'}>
              <Form.Group>
                <Form.Label>{t('label:value')} - Reembolsável</Form.Label>
                <div className="row pl-3 pr-3">
                  <Form.Control
                    as="select"
                    value={getCurrency()}
                    onChange={(e) => {
                      setCurrencyValue(e.target.value);
                      const c = () => {
                        return e.target.value==='1'?'R$':(
                          e.target.value==='2'?'$':'€'
                        );
                      };
                      let valor_limite = maxValue + addMaxValue;
                      let valor = currencyReverse(value);
                      if(e.target.value === '1' && currency!=='1')
                        valor = valor/(cotacao?cotacao:1);
                      
                      if (!courtesy && valor > valor_limite) {
                        toast.warning(
                          `${t('error:not exceed the value of')} ${c()} ${(
                            valor_limite*((e.target.value === '1' && currency!=='1') && cotacao?cotacao:1)
                          ).toLocaleString('pt-BR')}`
                        );
                        if(e.target.value === '1' && currency!=='1')
                        setValue((valor_limite*(cotacao?cotacao:1))+0.00001);
                        else
                        setValue(valor_limite+0.00001);
                      }
                    }}
                    disabled={vinculated.length === 0}
                    className="col-auto col-md-2"
                  >
                    {/* {getListSelectCurrency()} */}
                    <option value={1}>R$</option>                    
                    {currency == '2' ? (
                      <option value={2}>$</option>
                    ) : currency == '3' ? (
                      <option value={3}>€</option>
                    ): null }
                  </Form.Control>
                  
                  {getCurrencyTag(value,setValue)}
                </div>
                {getCurrency() === '1' && currency!=='1'?(
                <Form.Text className="text-muted">
                  {getText()}
                </Form.Text>
                ):''}
              </Form.Group>
            </Col>
            {
              getCurrency() === '1' && currency!=='1'?(
                <Col md={'5'}>
                  <Form.Group>
                <Form.Label>Cotação</Form.Label>
                <Form.Control
                  as="select"
                  value={cotacao}
                  onChange={(e) => {
                    const c = () => {
                      return getCurrency()==='1'?'R$':(
                        getCurrency()==='2'?'$':'€'
                      );
                    };
                    let valor_limite = maxValue + addMaxValue;
                    let valor = currencyReverse(value);
                    if(getCurrency() === '1' && currency!=='1')
                      valor = valor/(e.target.value?e.target.value:1);

                    if (!courtesy && valor > valor_limite) {
                      toast.warning(
                        `${t('error:not exceed the value of')} ${c()} ${(
                          valor_limite*((getCurrency() === '1' && currency!=='1') && e.target.value?e.target.value:1)
                        ).toLocaleString('pt-BR')}`
                      );
                      if(getCurrency() === '1' && currency!=='1')
                      setValue(valor_limite*(e.target.value?e.target.value:1)+0.00001);
                      else
                      setValue(valor_limite+0.00001);
                    }
                    setCotacao(e.target.value);
                  }}
                  disabled={vinculated.length === 0}
                >
                  {getListSelectCotacao()}
                  
                </Form.Control>
              
              </Form.Group>
            
                </Col>
              ):''
            }
            <Col md={getCurrency() === '1' && currency!=='1'?'7':'12'}>
              <Form.Group>
                <Form.Label>{t('label:value')} - Não Reembolsável</Form.Label>
                <div className="row pl-3 pr-3">
                  <Form.Control
                    as="select"
                    value={getCurrency()}
                    onChange={(e) => {
                      setCurrencyValue(e.target.value);
                      const c = () => {
                        return e.target.value==='1'?'R$':(
                          e.target.value==='2'?'$':'€'
                        );
                      };
                      let valor_limite = maxValue + addMaxValue;
                      let valor = currencyReverse(value);
                      if(e.target.value === '1' && currency!=='1')
                        valor = valor/(cotacao?cotacao:1);
                      
                      if (!courtesy && valor > valor_limite) {
                        toast.warning(
                          `${t('error:not exceed the value of')} ${c()} ${(
                            valor_limite*((e.target.value === '1' && currency!=='1') && cotacao?cotacao:1)
                          ).toLocaleString('pt-BR')}`
                        );
                        if(e.target.value === '1' && currency!=='1')
                        setValue((valor_limite*(cotacao?cotacao:1))+0.00001);
                        else
                        setValue(valor_limite+0.00001);
                      }
                    }}
                    disabled={vinculated.length === 0}
                    className="col-auto col-md-2"
                  >
                    {/* {getListSelectCurrency()} */}
                    <option value={1}>R$</option>                    
                    {currency == '2' ? (
                      <option value={2}>$</option>
                    ) : currency == '3' ? (
                      <option value={3}>€</option>
                    ): null }
                  </Form.Control>
                  
                  {getCurrencyTag(valueNonRefundable,setValueNonRefundable)}
                </div>
                {getCurrency() === '1' && currency!=='1'?(
                <Form.Text className="text-muted">
                  {getText()}
                </Form.Text>
                ):''}
              </Form.Group>
            </Col>
            {
              getCurrency() === '1' && currency!=='1'?(
                <Col md={'5'}>
                  <Form.Group>
                <Form.Label>Cotação</Form.Label>
                <Form.Control
                  as="select"
                  value={cotacao}
                  onChange={(e) => {
                    const c = () => {
                      return getCurrency()==='1'?'R$':(
                        getCurrency()==='2'?'$':'€'
                      );
                    };
                    let valor_limite = maxValue + addMaxValue;
                    let valor = currencyReverse(value);
                    if(getCurrency() === '1' && currency!=='1')
                      valor = valor/(e.target.value?e.target.value:1);

                    if (!courtesy && valor > valor_limite) {
                      toast.warning(
                        `${t('error:not exceed the value of')} ${c()} ${(
                          valor_limite*((getCurrency() === '1' && currency!=='1') && e.target.value?e.target.value:1)
                        ).toLocaleString('pt-BR')}`
                      );
                      if(getCurrency() === '1' && currency!=='1')
                      setValue(valor_limite*(e.target.value?e.target.value:1)+0.00001);
                      else
                      setValue(valor_limite+0.00001);
                    }
                    setCotacao(e.target.value);
                  }}
                  disabled={vinculated.length === 0}
                >
                  {getListSelectCotacao()}
                  
                </Form.Control>
              
              </Form.Group>
            
                </Col>
              ):''
            }
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:brief description')}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="4"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                  disabled={vinculated.length === 0}
                />
              </Form.Group>
            </Col>
          </Row>
          {vinculated === 'new' ||  vinculated == "credit_card"? (
            <Row>
              <Col>
                <FileUploadMultiple
                  files={files}
                  setFiles={(files) => setFiles(files)}
                  filesComments={filesComments}
                  setFilesComments={(filesComments) =>
                    setFilesComments(filesComments)
                  }
                  existingFiles={[]}
                />
              </Col>
            </Row>
          ) : null}
          <Row>
            <Col>
              {description.files &&
                description.files.map((file, k) => (
                  <File
                    key={k}
                    extension={file.extension}
                    comment={file.comment}
                    uri={file.uri}
                  />
                ))}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="danger" onClick={handleHideModal}>
            {t('label:cancel')}
          </Button>
          {isLoad ? (
            <Row className="float-right text-right">
              <Spinner animation="border" style={{ color: '#e05c17' }} />
              <h6 className="m-2">Salvando...</h6>
            </Row>
          ) : (
              <Button size="sm" onClick={() => handleSave()}>
                {t('label:save')}
              </Button>
            )}
        </Modal.Footer>
      </Modal>
      <Dialog
        ref={(component) => {
          dialog = component;
        }}
      />
      <Row className="mt-2">
        <Col>
          {!editable ? <PadLock /> : null}
          <Row>
            <Col>
              <h4>{t('title:description amount')}</h4>
            </Col>
          </Row>
          {expenseDescriptions.map((description, k) => {
          return (
            <Row key={k} className={`mt-3 ${style.expenseDescription} ${
              description.hidden || description.hidden==undefined ? style.hidden : null
              }`}>
              <Col xs="12">
                <Row className="justify-content-between">
                  <Col xs="auto">
                    <ReactTooltip place="right"/>
                    <h5 
                      className="" 
                      data-html={true} 
                      data-tip={`${getDescription(description.approval_history,description.status_id)} ${description.is_advance ? ' - Adiantamento' : ''}` }
                    >
                      {getStatus(description.status_id)}
                      {' '}
                      {description.is_advance ? <small><TextFormatOutlined /></small> : ''}
                    </h5>
                  </Col>
                  <Col>
                    {description.hidden || description.hidden==undefined ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{t('label:expand')}</Tooltip>}
                      >
                        <i
                          className="expenseDescriptionIcon fas fa-plus"
                          onClick={() => setHidden(false, k)}
                        />
                      </OverlayTrigger>
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{t('label:minimize')}</Tooltip>}
                      >
                        <i
                          className="expenseDescriptionIcon fas fa-minus"
                          onClick={() => setHidden(true, k)}
                        />
                      </OverlayTrigger>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md={'6'}>
                    <Form.Group>
                      <Form.Label>{t('label:service provider')}</Form.Label>
                      <Form.Control
                        value={description.service_provider}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={'6'}>
                    <Form.Group>
                      <Form.Label>{t('label:type')}</Form.Label>
                      <Form.Control
                        value={
                          description.vinculated_nf === 1
                            ? t('label:exist nf')
                            : t('label:add new nf')
                        }
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>  
                <Col md={description.currency!=currency?'3':'6'}>
                    <Form.Group>
                      <Form.Label>{t('label:value')} - Não Reembolsável</Form.Label>
                      {
                        description.currency!=currency
                        ?
                        (
                          <Currency value={description.non_refundable} disabled />
                        )
                        :
                        (currency==='1'?(
                          <Currency value={description.non_refundable} disabled />
                        ):currency==='2'?(
                          <DollarCurrency value={description.non_refundable} disabled/>
                        ):(
                          <EuroCurrency value={description.non_refundable} disabled/>
                        ))
                      }
                    </Form.Group>
                  </Col>
                  <Col md={description.currency!=currency?'3':'6'}>
                    <Form.Group>
                      <Form.Label>{t('label:value')} - Reembolsável</Form.Label>
                      {
                        description.currency!=currency
                        ?
                        (
                          <Currency value={description.value} disabled />
                        )
                        :
                        (currency==='1'?(
                          <Currency value={description.value} disabled />
                        ):currency==='2'?(
                          <DollarCurrency value={description.value} disabled/>
                        ):(
                          <EuroCurrency value={description.value} disabled/>
                        ))
                      }
                    </Form.Group>
                  </Col>
                  {description.currency!=currency?(
                    <Col md={'3'}>
                      <Form.Group>
                        <Form.Label>Cotação</Form.Label>
                        <Currency value={description.value_cotacao?description.value_cotacao:1} disabled />
                      </Form.Group>
                    </Col>
                  ):''}
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:invoice number')}</Form.Label>
                      <Form.Control
                        value={description.invoice_number}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:expiry')}</Form.Label>
                      <DatePicker
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        locale="pt_BR"
                        selected={description.due_date}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                  <Form.Group>
                    <Form.Label>{t('label:issuance_date')}</Form.Label>
                    <DatePicker
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      locale="pt_BR"
                      selected={description.issuance_date}
                      disabled
                      // minDate={paymentMethod == 1 ? dueDateMin : ""}
                      required
                    />
                  </Form.Group>
                </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:brief description')}</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows="4"
                        value={description.description}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>                    
                <Row>
                  <Col>
                    {description.file ? (
                      <File
                        extension={description.file.extension}
                        comment={description.file.comment}
                        uri={description.file.uri}
                      />
                    ) : ('')}                    
                  </Col>
                </Row>
                {description.generate_payment ? (<>
                  <Row>
                    <Col>
                      <h5>Informações de Pagamento</h5>
                    </Col>
                  </Row>
                  <Row>
                    {description.payment_method_id == 1 
                    ? (
                        <>
                          <Col>
                            <Form.Group>
                              <Form.Label>Tipo</Form.Label>
                              <Form.Control
                                value={'Boleto'}
                                disabled
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group>
                              <Form.Label>{t('label:expiry')}</Form.Label>
                              <DatePicker
                                className="form-control"
                                dateFormat="dd/MM/yyyy"
                                locale="pt_BR"
                                selected={description.billet_due_date}
                                disabled
                              />
                            </Form.Group>
                          </Col>
                        </>
                      )
                    : (
                      <>
                        <Col xs={6}>
                          <Form.Group>
                            <Form.Label>Tipo</Form.Label>
                            <Form.Control
                              value={'Transferência Bancária'}
                              disabled
                            />
                          </Form.Group>
                        </Col>
                        <Col xs={6}>
                          <Form.Group>
                            <Form.Label>Banco</Form.Label>
                            <Form.Control
                              value={getBankName(description.bank_code)}
                              disabled
                            />
                          </Form.Group>
                        </Col>
                        <Col xs={4}>
                          <Form.Group>
                            <Form.Label>Agência</Form.Label>
                            <Form.Control
                              value={description.agency}
                              disabled
                            />
                          </Form.Group>
                        </Col>
                        <Col xs={4}>
                          <Form.Group>
                            <Form.Label>Conta</Form.Label>
                            <Form.Control
                              value={description.account}
                              disabled
                            />
                          </Form.Group>
                        </Col>
                        <Col xs={4}>
                          <Form.Group>
                            <Form.Label>CNPJ</Form.Label>
                            <Form.Control
                              value={description.document}
                              disabled
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )}                  
                  </Row>              
                 </>)
                : null }

                <Row className="mt-2 mb-1">
                  <Col>
                    <h5>{t('title:project info')}</h5>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:nature')}</Form.Label>
                      <Form.Control value={description.nature} disabled />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:cost center')}</Form.Label>
                      <Form.Control value={description.cost_center} disabled />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:project')}</Form.Label>
                      <Form.Control value={description.project} disabled />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:project action')}</Form.Label>
                      <Form.Control
                        value={description.project_action}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {listFiles(description)}
                  </Col>
                </Row>
                {description.parent_id ? '' : (
                  <Row>
                    <Col>
                      <Button
                        size="sm"
                        onClick={() => handleEdit(k)}
                        disabled={!(description.status_id !== 8 && description.status_id !== 6)}
                      >
                        {t('label:edit')}
                      </Button>
                      &nbsp;
                      <Button
                        size="sm"
                        variant="danger"
                        onClick={() => deleteDescription(description.id)}
                        disabled={!editable || description.status_id !== 7}
                      >
                        <i className="fas fa-trash" />
                      </Button>
                      {description.payment_method_id == 3 && !hasFiles(description)?(
                        <Button
                          className="ml-1"
                          size="sm"
                          onClick={() => {
                            setIdAddFile(description.id)
                            setShowAddFile(true)
                          }}
                        >
                          Inserir Nota
                        </Button>
                      ):""}
                    </Col>
                  </Row>  
                )}
              </Col>
            </Row>
          )})}
          <Row className="mt-2 mb-4">
            <Col>
              <Button
                size="sm"
                variant="dark"
                onClick={() => setShowModal(true)}
                disabled={(parseFloat(maxValue) === 0) && !courtesy} //(!editable || parseFloat(maxValue) === 0) && !courtesy}
              >
                <i className="fas fa-plus" /> {t('label:add new')}
              </Button>
            </Col>

            <Col className="mt-2 text-right">
              <b>Total:</b>{' '}
              {(currency==='1'?'R$ ':(currency==='2'?'$ ':'€ '))+parseFloat(total).toFixed(2).replace('.',',')}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  loading: (payload) => dispatch({ type: LOADING, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionsFormExpenseDescriptions);